<template>
  <el-tree-select
    v-model="value"
    :data="options"
    :render-after-expand="renderAfterExpand"
    :multiple="multiple"
    :show-checkbox="showCheckbox"
    filterable
    :clearable="multiple"
  />
</template>

<script lang="ts" setup>
  import { ElTreeSelect } from 'element-plus';
  import { ref } from 'vue';

  export interface Props {
    placeholder?: string;
    options?: any[];
    disabled?: boolean;
    compact?: boolean;
    multiple?: boolean;
    showCheckbox?: boolean;
    renderAfterExpand?: boolean;
  }

  withDefaults(defineProps<Props>(), {
    placeholder: 'Select option',
    renderAfterExpand: true,
  });

  const value = ref('');

  defineEmits(['change']);
</script>

<style lang="scss">
  .el-select__wrapper {
    padding: 1rem 1.25rem;
  }
</style>
